<template>
  <div class="plate-constituent-stock">
    <Header :title="title" />
    <div class="main-content">
      <ul class="table-header">
        <li class="stock-name">股票名称</li>
        <li class="stock-price">最新价</li>
        <li class="stock-chr" @click="onSort('')">涨跌幅<img :src="chrSortIcon" alt=""></li>
      </ul>

      <ul class="table-body">
        <li v-for="(item, index) in bkStockList" :key="index" @click="goTo(item)">
          <div class="stock-name">{{item.prodName}}<br><span>{{item.prodCode}}</span></div>
          <div class="stock-price" :class="[item.pxChangeRate > 0 ? 'rise-color' : item.pxChangeRate == 0 ? '' : 'fall-color']">{{item.lastPx ? (item.lastPx / 1000).toFixed(2) : '--'}}</div>
          <div class="stock-chr" :class="[item.pxChangeRate > 0 ? 'rise-color' : item.pxChangeRate == 0 ? '' : 'fall-color']">{{item.pxChangeRate > 0 ? '+' : ''}}{{item.pxChangeRate || item.pxChangeRate == 0 ? item.pxChangeRate == 0 ? '0.00%' : (item.pxChangeRate / 100 ).toFixed(2)+ '%' : '--'}}</div>
        </li>
      </ul>

    <infinite-loading ref="plateStock" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="bkStockList.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading>

    </div>
  </div>
</template>

<script>
import {request} from '@/api/request'
import Header from '@/components/header.vue'
import InfiniteLoading from 'vue-infinite-loading'

let HqTypeCode, ProdCode

export default {
  data () {
    return {
      title: '',
      sortFlag: true,
      sortType: '',
      pageNum: 0,
      bkStockList: [],
      noData: false,
      defaultImg: require('../../assets/sort-default.png'),
      descImg: require('../../assets/sort-desc.png'),
      ascImg: require('../../assets/sort-asc.png')
    }
  },
  components: {Header, InfiniteLoading},
  created () {
    const {block: hqTypeCode, code: prodCode} = this.$route.params
    HqTypeCode = hqTypeCode
    ProdCode = prodCode
  },
  computed: {
    priceSortIcon () {
      const {sortFlag, sortType, defaultImg, descImg, ascImg} = this
      // debugger
      return !sortType ? defaultImg : sortFlag ? descImg : ascImg
    },
    chrSortIcon () {
      const {sortFlag, sortType, defaultImg, descImg, ascImg} = this
      // debugger
      return sortType === 'lastPx' ? defaultImg : sortFlag ? descImg : ascImg
    }
  },
  methods: {
    goTo(item) {
      const {hqTypeCode, prodCode} = item
      this.$router.push(`/${hqTypeCode.includes('XSHG') ? 'sh' : 'sz'}/${prodCode}.html`)
    },
    async infiniteHandler($state) {
      this.pageNum++
      let canload = await this.getLists()
      if (canload) $state.loaded()
      else $state.complete()
    },
    async getLists (type) {
      const url = request.apis.quote.queryStockGrp
      const {sortFlag, pageNum, sortType, hqTypeCode, prodCode} = this
      let params = {
        hqTypeCode: HqTypeCode,
        prodCode: ProdCode,
        sortFlag,
        pageSize: 50,
        pageNum,
        simPageSize: 'yes'
      }
      // if (sortType) {
      //   params = Object.assign(params, {sortType})
      // }
      const res = await request.get({
        url,
        params
      })
      if (!res) return this.title = '--'
      const {plate, sortProdGrp} = res
      if (plate&&!this.title) {
        this.title = plate.ProdName
      }
      if(type === 'init') {
        this.bkStockList = sortProdGrp
        window.scrollTo(0,0)
        return
      }
      if (sortProdGrp&&sortProdGrp.length) {
        this.bkStockList = this.bkStockList.concat(sortProdGrp)
        return true
      } else {
        return false
      }
    },
    onSort (sortType) {
      // if (sortType === this.sortType) {
      //   if (sortType === 'lastPx' && this.sortFlag) { // 连续点击最新价排序第三次按默认排序
      //     this.sortType = ''
      //     this.sortFlag = true
      //   } else {
      //     this.sortFlag = !this.sortFlag
      //   }
      // } else {
      //   this.sortType = sortType
      //   this.sortFlag = false
      // }
      this.sortFlag = !this.sortFlag
      this.pageNum = 1
      this.getLists('init')
    }
  }
}
</script>

<style lang="stylus" scoped>
.plate-constituent-stock
  height 100%
  background white

.table-header
  position -webkit-sticky
  position sticky
  top 30px
  display flex
  justify-content space-between
  padding-top 8px
  color #999999
  background #fff
  img
    width 7px
    margin-left 3px

.main-content
  margin-top 40px
  padding 0 12px

.stock-name
  width 45%
  text-align left 
  span
    color #999999
    font-size 13px
    font-font-weight normal

.stock-price
  width 25%
  text-align right

.stock-chr
  text-align right
  width 25%

.table-body li
  height 50px
  margin-top 5px
  display flex
  justify-content space-between
  align-items center

.table-body
  .stock-name
    font-size 17px
    font-weight bold
    font-weight 500
  .stock-price,.stock-chr
    font-size 18px
    font-weight bold
</style>